export default __webpack_public_path__ + "static/media/logo_write.276a761b.png";